import { Pill, TextProps } from '@mantine/core';

import { Nomenclature } from '@feature/nomenclature';

export interface WosIndexAsProps extends TextProps {
  type: Nomenclature | null;
}

export function WosIndexAs(props: WosIndexAsProps) {
  const { type } = props;

  if (type == null) return null;

  return (
    <Pill
      bg="orange"
      c="white"
    >
      {type.name}
    </Pill>
  );
}
